import { deleteVitals } from "../../api/historyService";

export const useDeleteVitals = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteVitals(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete vitals:", error);
            throw error;
        }
    };

    return { remove };
};